import React from 'react';
import { Grid, Typography } from '@mui/material';
import * as yup from 'yup';
import {
  SparkDropdown,
  SparkForm,
  SparkFormPhoneInput,
  SparkTextField,
} from 'sharedComponents/SparkForm';
import Footer from 'components/AuthScreens/Register/Stepper/Footer';
import { useCountries } from 'hooks/Countries/useCountries';

export type CreatorBasicInfoFormValues = {
  name: string;
  displayName: string;
  countryID: string;
  email: string;
  phone: string;
};

type CreatorBasicInfoFormProps = {
  activeStep: number;
  nextStepHandler: () => void;
  basicInfoCollection?: CreatorBasicInfoFormValues;
  setBasicInfoCollection: (formValues: CreatorBasicInfoFormValues) => void;
};

function CreatorBasicInfoForm({
  activeStep,
  nextStepHandler,
  basicInfoCollection,
  setBasicInfoCollection,
}: CreatorBasicInfoFormProps) {
  const {
    dropdownOptions: countries,
    countryCodeDropdownOptions: countriesOptions,
  } = useCountries();

  const initialValues: CreatorBasicInfoFormValues = basicInfoCollection || {
    name: '',
    displayName: '',
    countryID: '',
    email: '',
    phone: '',
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required('Required'),
    displayName: yup.string().required('Required'),
    countryID: yup.string().required('Required'),
    email: yup.string().required('Required'),
  });

  const handleSubmit = (values: CreatorBasicInfoFormValues) => {
    setBasicInfoCollection(values);
    nextStepHandler();
  };

  return (
    <SparkForm
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSave={handleSubmit}
    >
      <Grid item xs={12}>
        <Typography variant='h5' fontFamily='Mont-semibold' pt={2}>
          Activate your Creator Account
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1' pb={2}>
          Turn your skills into revenue.
        </Typography>
      </Grid>
      <SparkTextField
        name='name'
        label='Full Name'
        placeholder='Enter your name'
        size={12}
        helpText='Your Full Name here'
      />
      <SparkTextField
        name='displayName'
        label='Display Name'
        placeholder='Enter your display name'
        size={12}
        helpText='Your Display Name here'
      />
      <SparkDropdown
        name='countryID'
        label='Country'
        placeholder='Please select'
        size={12}
      >
        {countries}
      </SparkDropdown>
      <SparkTextField
        name='email'
        label='Email'
        placeholder='Please select'
        size={12}
      />

      <SparkFormPhoneInput
        name='phone'
        label='Phone'
        countriesOptions={countriesOptions}
        size={12}
      />
      <Footer
        activeStep={activeStep}
        isLastStep={false}
        isParentLoading={false}
        isFirstStep={true}
      />
    </SparkForm>
  );
}

export default CreatorBasicInfoForm;
